module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-00.9086fe32.png";